import { useMemo } from "react";

import MfaOtpChallengeInstance from "@auth0/auth0-acul-js/mfa-otp-challenge";
import type { ScreenMembersOnMfaOtpChallenge } from "@auth0/auth0-acul-js/mfa-otp-challenge";

import { executeSafely } from "../utils/helpers/executeSafely";

export const useMfaChallengeManager = () => {
  const mfaChallengeInstance = useMemo(
    () => new MfaOtpChallengeInstance(),
    []
  );

  const { screen } = mfaChallengeInstance;
  const { texts, data } = screen as ScreenMembersOnMfaOtpChallenge;

  const handleContinue = async (
    code: string,
    rememberDevice?: boolean
  ): Promise<void> => {
    const options: { code: string; rememberDevice?: boolean } = {
      code: code?.trim() || "",
    };

    if (rememberDevice) {
      options.rememberDevice = true;
    }

    executeSafely(`MFA OTP continue with code`, () =>
      mfaChallengeInstance.continue(options)
    );
  };

  const handleTryAnotherMethod = (): void => {
    executeSafely("MFA try another method", () =>
      mfaChallengeInstance.tryAnotherMethod()
    );
  };

  return {
    mfaChallengeInstance,
    handleContinue,
    handleTryAnotherMethod,
    texts: (texts || {}) as Record<string, string>,
    errors: mfaChallengeInstance.getError(),
    showRememberDevice: data?.showRememberDevice === true,
  };
};
